export default "__VITE_ASSET__DkOG9hcU__"